import React, { FC, useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Slider,
  Stack,
  Typography,
} from '@mui/material';
import { Edit } from '../../constructor/work/Edit';
import { ItemSelectSupport } from './ItemSelectSupport';
import { SelectSupportType } from './SelectSupportType';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

const SizesTiles = [
  '600 x 600 x 20',
  '600 x 1200 x 20',
  '500 x 500 x 20',
  '400 x 400 x 20',
  '300 x 600 x 20',
  '300 x 1200 x 20',
  '300 x 300 x 20',
];

interface Props {
  setDisableRootControl(val: boolean): void;
}
export const CalcSupportsForTiles: FC<Props> = ({ setDisableRootControl }) => {
  const [value, setValue] = useState(SizesTiles[0]);
  const [isDisableButton, setIsDisableButton] = useState<boolean>(
    !!Edit.sectionsObjects && !Edit.supportsGroup
  );
  const [offsetX, setOffsetX] = useState(() => {
    if (Edit.supportsGroup) {
      return Edit.supportsGroup.customerOffsetX * 1000;
    }
    return 0;
  });
  const [offsetZ, setOffsetZ] = useState(() => {
    if (Edit.supportsGroup) {
      return Edit.supportsGroup.customerOffsetZ * 1000;
    }
    return 0;
  });
  const [isCollapseRadio, setIsCollapseRadio] = useState(true);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };
  const handlerCalculationSupports = () => {
    const data = value.replace(/\s/g, '').split('x');
    const offsetX = +data[0] / 1000;
    const offsetZ = +data[1] / 1000;
    const depthTile = +data[2] / 1000;
    setIsDisableButton(false);
    Edit.addSupportsObjects({ depthTile, offsetX, offsetZ });
    setDisableRootControl(true);
  };
  const removeSupports = () => {
    Edit.removeSupportsObjects();
    setIsDisableButton(true);
    setOffsetX(0);
    setOffsetZ(0);
    setDisableRootControl(false);
  };
  const getItemSelectSupports = () => {
    if (Edit?.supportsGroup?.selectSupports) {
      const _selSupp = Edit.supportsGroup.selectSupports;
      const keysSupport = Object.keys(Edit.supportsGroup.selectSupports);
      keysSupport.sort();
      return keysSupport.map(item => {
        return (
          <ItemSelectSupport
            key={item}
            color={_selSupp[item].color}
            title={item}
            quantity={_selSupp[item].quantity}
          />
        );
      });
    }
  };
  const getMaxSlider = (index: number) => {
    return parseInt(value.replace(/ /g, '').split('x')[index]) / 2;
  };
  const handlerSliderMouseUp = () => {
    // console.log('up', offsetX / 1000);
    const data = value.replace(/\s/g, '').split('x');
    const offsetX = +data[0] / 1000;
    const offsetZ = +data[1] / 1000;
    const customerOffsetX = offsetX / 1000;
    const customerOffsetZ = offsetZ / 1000;
    const depthTile = +data[2] / 1000;
    if (Edit.supportsGroup) {
      Edit.removeSupportsObjects();
      Edit.addSupportsObjects({ depthTile, offsetX, offsetZ, customerOffsetX, customerOffsetZ });
    }
  };
  const getCompensatingLining = () => {
    if (Edit.supportsGroup?.compensatingLining) {
      return (
        <Typography mt={3} mb={3} color="#fff">
          {`Кол - во компенсирующих подкладок: ${Edit.supportsGroup.compensatingLining} шт.`}
        </Typography>
      );
    }
    return null;
  };

  return (
    <Stack display="flex" flexDirection="column" pb={10}>
      <Button
        disabled={!isDisableButton}
        fullWidth
        variant="contained"
        onClick={handlerCalculationSupports}
        sx={{
          marginBottom: '30px',
          flexDirection: 'column',
          '&:disabled': {
            color: 'rgba(255,255,255,0.53)',
            backgroundColor: 'rgba(0,0,0,0.45)',
          },
        }}
      >
        <Typography fontSize="12px" component="span">
          Рассчитать для плитки
        </Typography>
        <Typography fontSize="12px" component="span">
          {value}
        </Typography>
      </Button>
      <Button
        fullWidth
        variant="contained"
        onClick={removeSupports}
        sx={{
          marginBottom: '10px',
          flexDirection: 'column',
          '&:disabled': {
            color: 'rgba(255,255,255,0.53)',
            backgroundColor: 'rgba(0,0,0,0.45)',
          },
        }}
      >
        Удалить опоры
      </Button>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography fontSize="12px" color="#fff" component="span" mr={2}>
          Размеры
        </Typography>
        <Box flex={1} height="1px" bgcolor="#fff" />
        <IconButton
          sx={{ color: '#fff' }}
          onClick={() => {
            setIsCollapseRadio(!isCollapseRadio);
          }}
        >
          {!isCollapseRadio ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </IconButton>
      </Box>
      <Collapse in={isCollapseRadio}>
        <FormControl fullWidth disabled={!!Edit?.supportsGroup}>
          <FormLabel
            sx={{
              color: '#ffffff',
              '&.Mui-disabled': {
                color: '#6e6e6e',
              },
            }}
          >
            Выберите размер плиточного материала
          </FormLabel>

          <RadioGroup value={value} onChange={handleChange}>
            {SizesTiles.map(item => (
              <FormControlLabel
                sx={{ color: '#ffffff' }}
                key={item}
                value={item}
                control={
                  <Radio
                    sx={{
                      '&.Mui-disabled': {
                        color: '#6e6e6e',
                      },
                    }}
                  />
                }
                label={`${item} mm`}
              />
            ))}
          </RadioGroup>
        </FormControl>
        <Typography color={!Edit.supportsGroup ? '#797979' : 'white'} gutterBottom mt={2}>
          Сдвинуть опоры влево
        </Typography>
        <Slider
          disabled={!Edit.supportsGroup}
          onMouseUp={handlerSliderMouseUp}
          value={offsetX}
          onChange={(e, v) => setOffsetX(+v)}
          valueLabelDisplay="auto"
          step={10}
          min={0}
          max={getMaxSlider(0)}
        />
        <Typography color={!Edit.supportsGroup ? '#797979' : 'white'} gutterBottom mt={2}>
          Сдвинуть опоры вниз
        </Typography>
        <Slider
          disabled={!Edit.supportsGroup}
          onMouseUp={handlerSliderMouseUp}
          value={offsetZ}
          onChange={(e, v) => setOffsetZ(+v)}
          valueLabelDisplay="auto"
          step={10}
          min={0}
          max={getMaxSlider(1)}
        />
      </Collapse>

      <SelectSupportType />
      <Typography mt={3} mb={3} color="#fff">
        Кол-во опор:
      </Typography>
      {getItemSelectSupports()}
      {getCompensatingLining()}
    </Stack>
  );
};
